var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_49",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6592",
    "data-name": "Group 6592",
    transform: "translate(-6 -1330)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 6, 1330)",
    filter: "url(#Ellipse_49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_49-2",
    "data-name": "Ellipse 49",
    transform: "translate(9 6)",
    fill: "#f9f9f9",
    stroke: "#e9e9e9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1907",
    "data-name": "Group 1907",
    transform: "translate(39 1362.82) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1877",
    "data-name": "Group 1877",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1876",
    "data-name": "Group 1876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M1.47,6.892,6.641,1.484a.24.24,0,0,1,.334,0,.237.237,0,0,1,.009.321L1.967,7.055,6.984,12.3a.232.232,0,0,1-.035.33.228.228,0,0,1-.3-.009L1.47,7.218a.237.237,0,0,1,0-.321Z",
    transform: "translate(-1.227 -1.232)",
    fill: "#5186ec",
    stroke: "#5186ec",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M6.583,12.638a.414.414,0,0,0,.3-.7L1.979,6.82,6.882,1.7a.414.414,0,0,0-.6-.572L1.113,6.534a.406.406,0,0,0,0,.567L6.284,12.51a.406.406,0,0,0,.3.128Zm0-11.287s.031,0,.04.018a.061.061,0,0,1,0,.084L1.491,6.816l5.136,5.369a.059.059,0,1,1-.084.084h0L1.368,6.86a.061.061,0,0,1,0-.084l5.171-5.4a.108.108,0,0,1,.044-.018h0Z",
    transform: "translate(-0.997 -0.997)",
    fill: "#5186ec",
    stroke: "#5186ec",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.7f3a7fd556e48533eb46b9167d5d77f4.svg";
export { ForwardRef as ReactComponent };